import { render, staticRenderFns } from "./ComplaintList.vue?vue&type=template&id=178c461c&scoped=true"
import script from "./ComplaintList.vue?vue&type=script&lang=js"
export * from "./ComplaintList.vue?vue&type=script&lang=js"
import style0 from "./ComplaintList.vue?vue&type=style&index=0&id=178c461c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178c461c",
  null
  
)

export default component.exports